<mat-card>
	<img mat-card-image class="mat-card-image" [src]="logo" />
	<mat-card-header>
		<mat-card-title><h3>{{organization.name}}</h3></mat-card-title>
	</mat-card-header>
</mat-card>
